<template>
  <div>
    <fccSelecaoDeFaseEGrupo
      :configuracao="configuracao"
      :abaDesabilitada="abaDesabilitada"
      @atualizar-lista="listarConfiguracaoDefinidaDasDatasEGruposDeAplicacao"
    />
    <fccConfiguracaoDefinidaDasDatasEGrupos
      :configuracao="configuracao"
      :lista="configuracaoDefinidaDasDatasEGrupos"
      :abaDesabilitada="abaDesabilitada"
      @atualizar-lista="listarConfiguracaoDefinidaDasDatasEGruposDeAplicacao"
      @finalizado="$emit('finalizado')"
      v-if="configuracaoDefinidaDasDatasEGrupos.length > 0"
    />
  </div>
</template>
<script>
import axios from 'axios'
import fccStore from '../../../../../store'
import fccConfiguracaoDefinidaDasDatasEGrupos from './fccConfiguracaoDefinidaDasDatasEGrupos.vue'
import fccSelecaoDeFaseEGrupo from './fccSelecaoDeFaseEGrupo.vue'

export default {
  components: { fccSelecaoDeFaseEGrupo, fccConfiguracaoDefinidaDasDatasEGrupos },
  computed: {
    configuracao() {
      return fccStore.state.localDeProva.configuracao
    }
  },
  props: ['abaDesabilitada'],
  data() {
    return {
      configuracaoDefinidaDasDatasEGrupos: []
    }
  },
  created() {
    this.listarConfiguracaoDefinidaDasDatasEGruposDeAplicacao()
  },
  methods: {
    listarConfiguracaoDefinidaDasDatasEGruposDeAplicacao() {
      axios
        .get(
          fccStore.state.baseUrlLocalDeProva +
            `DataGrupo/Listar/${this.configuracao.idlocalconfig}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.configuracaoDefinidaDasDatasEGrupos = response.data
        })
        .catch(this.setErrorSystem)
    }
  },
  watch: {
    configuracao() {
      this.listarConfiguracaoDefinidaDasDatasEGruposDeAplicacao()
    }
  }
}
</script>